import { FormField } from './formField' // eslint-disable-line no-unused-vars
import { FormTemplate } from '../templating/formTemplate' // eslint-disable-line no-unused-vars

/**
 * A form encapsulates fields, a name, and a set of identifiers.
 *
 * @class Form
 */

export class Form {
  /**
   * Creates an instance of ManufacturerProfile.
   * @param {String} name The manufacturer name.
   * @param {[FormField]} fields An array of form fields
   * @param {[FormTemplate]} submissionTemplate A template used to process user input, to convert it to a submission.
   * @param {[FormTemplate]} initializationTemplate A template used to convert data objects into submission objects for editing.
   * @param {[Function]} validationRules Array of form validation functions.
   * @memberof Form
   */
  constructor (name, fields, submissionTemplate, initializationTemplate, validationRules) {
    this.version = 1
    this.name = name
    this.identifier = this.identifierFromName(name)

    this.groups = []
    this.fields = []

    if (fields.length > 0) {
      for (let index in fields) {
        let entry = fields[index]
        const isGroup = entry.fields
        if (isGroup) {
          // group
          this.groups.push(entry)
          entry.fields.forEach(field => this.fields.push(field))
        } else {
          // field
          this.fields.push(entry)
        }
      }
    }

    this.submissionTemplate = submissionTemplate
    this.initializationTemplate = initializationTemplate
    this.validationRules = validationRules
  }

  /**
   * Generates an identifier based on the user visible name.
   *
   * @param {any} name The name of the form.
   * @returns An identifier.
   * @memberof Form
   */
  identifierFromName (name) {
    return 'io.owal.' + name.toLowerCase().replace(/\W/g, '')
  }

  /**
   * Validates a submission for a given form by checking if all of the form's required fields have values.
   * This is a basic validation that needs work, but it's good enough for now.
   *
   * @param {any} submission The submission to validate.
   * @returns `true` if the submission is valid.
   * @memberof Form
   */
  validateSubmission (submission) {
    let valid = true
    const noMissingFields = !(this.fields.some(field => {
      return field.required && !submission.valueForField(field.identifier)
    }))
    if (this.validationRules) {
      this.validationRules.forEach(rule => {
        if (!rule.isValid(submission)) {
          valid = false
        }
      })
    }
    return noMissingFields && valid
  }
}
